module.exports = __webpack_public_path__ + "static/media/accumulate-for-education.2d96d1b0.png";